module.exports = __webpack_public_path__ + "static/media/scale-use-cases.5ed58d27.png";